// extracted by mini-css-extract-plugin
export default {"hr-desktop":"CyoSelector-module__hr-desktop__XDcHz","hr-mobile":"CyoSelector-module__hr-mobile__l4O9q"};